import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDescending = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.67056 8.21385C5.55705 8.10083 5.5 7.96562 5.5 7.80813C5.5 7.65345 5.55705 7.51975 5.67056 7.40683L6.00764 7.07248C6.11538 6.95934 6.25021 6.90304 6.41212 6.90304C6.57375 6.90304 6.70858 6.95934 6.81633 7.07248L8.13727 8.37876V5.24002C8.13727 5.08533 8.19344 4.95982 8.3058 4.86316C8.41816 4.7666 8.55385 4.71826 8.7126 4.71826H9.28736C9.44609 4.71826 9.5818 4.7666 9.69415 4.86316C9.80622 4.95982 9.8624 5.08533 9.8624 5.24002V8.37876L11.1787 7.07248C11.2928 6.95934 11.4291 6.90304 11.5878 6.90304C11.7466 6.90304 11.8828 6.95934 11.9966 7.07248L12.3337 7.40683C12.4443 7.52266 12.4999 7.65656 12.4999 7.80813C12.4999 7.9625 12.4443 8.09781 12.3337 8.21385L9.40865 11.1163C9.29801 11.2262 9.16174 11.2812 8.99983 11.2812C8.83532 11.2812 8.7005 11.2262 8.59562 11.1163L5.67056 8.21385Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 1.5H15V-0.5H3V1.5ZM17 3.5V12.5H19V3.5H17ZM15 14.5H3V16.5H15V14.5ZM1 12.5V3.5H-1V12.5H1ZM3 14.5C1.89543 14.5 1 13.6046 1 12.5H-1C-1 14.7091 0.790862 16.5 3 16.5V14.5ZM17 12.5C17 13.6046 16.1046 14.5 15 14.5V16.5C17.2091 16.5 19 14.7091 19 12.5H17ZM15 1.5C16.1046 1.5 17 2.39543 17 3.5H19C19 1.29086 17.2091 -0.5 15 -0.5V1.5ZM3 -0.5C0.790861 -0.5 -1 1.29086 -1 3.5H1C1 2.39543 1.89543 1.5 3 1.5V-0.5Z",
			fill: "#7F99B2"
		})
	]
});
const ForwardRef = forwardRef(SvgDescending);
export { ForwardRef as ReactComponent };
